import styled, { css } from 'styled-components'

const Greyscale = {
  black: '#272727',
  800: '#636B71',
  700: '#8E99A3',
  600: '#B6C5D0',
  500: '#C8D8E5',
  400: '#48bb77',
  300: '#DAE5EE',
  100: '#EEF3F7',
  white: '#FFFFFF',
}

const SiteSpacings = {
  Spacing01: {
    sm: 2,
    md: 2,
    lg: 2,
  },
  Spacing02: {
    sm: 4,
    md: 4,
    lg: 4,
  },
  Spacing03: {
    sm: 8,
    md: 8,
    lg: 8,
  },
  Spacing04: {
    sm: 16,
    md: 16,
    lg: 16,
  },
  Spacing05: {
    sm: 24,
    md: 24,
    lg: 24,
  },
  Spacing06: {
    sm: 32,
    md: 32,
    lg: 32,
  },
  Spacing07: {
    sm: 40,
    md: 48,
    lg: 48,
  },
  Spacing08: {
    sm: 48,
    md: 64,
    lg: 64,
  },
  Spacing09: {
    sm: 64,
    md: 80,
    lg: 96,
  },
  Spacing10: {
    sm: 96,
    md: 120,
    lg: 160,
  },
  Spacing11: {
    sm: 144,
    md: 184,
    lg: 240,
  },
  Spacing12: {
    sm: 184,
    md: 240,
    lg: 320,
  },
  Zero: {
    sm: 0,
    md: 0,
    lg: 0,
  },
  XSmall: {
    sm: 16,
    md: 16,
    lg: 16,
  },
  Small: {
    sm: 24,
    md: 24,
    lg: 24,
  },
  Regular: {
    sm: 32,
    md: 32,
    lg: 32,
  },
  Medium: {
    sm: 40,
    md: 48,
    lg: 48,
  },
  Large: {
    sm: 48,
    md: 64,
    lg: 64,
  },
  XLarge: {
    sm: 64,
    md: 80,
    lg: 96,
  },
  XXLarge: {
    sm: 96,
    md: 120,
    lg: 160,
  },
}

export const FooterContainer = styled.nav`
  ${({ theme, forgotDetails }) => css`
    margin-top: 80px;
    padding: ${SiteSpacings.Spacing05.sm}px ${SiteSpacings.Spacing06.sm}px;
    background-color: #013a68;
  `}
`

export const FooterCompanyName = styled.div`
  font-family: 'Life Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  color: white;
  margin-bottom: ${SiteSpacings.Spacing02.sm}px;
`

export const FooterCompanyLinks = styled.div`
  font-family: 'Life Sans';
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;

  @media screen and (min-width: 768px) {
    display: flex;
    flex-wrap: wrap;
    grid-column-gap: ${SiteSpacings.Spacing06.md}px;
  }

  li {
    padding-top: ${SiteSpacings.Spacing03.sm}px;
    padding-bottom: ${SiteSpacings.Spacing03.sm}px;
    display: block;

    a {
      font-weight: 400;
      color: white;
      text-decoration: underline;
      transition: color 0.3s cubic-bezier(0.25, 1, 0.5, 1);

      &:active,
      &:visited {
        color: white;
        text-decoration: underline;
      }

      &:hover,
      &:focus {
        color: ${Greyscale[300]};
        text-decoration: underline;
      }
    }
  }
`

export const FooterLinksWrapper = styled.div`
  margin-top: ${SiteSpacings.Spacing03.sm}px;
  padding-top: ${SiteSpacings.Spacing04.sm}px;
  border-top: 1px solid #c8d8e5;
`

export const FooterSocialLinks = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin-bottom: 0;
  text-align: left;

  li {
    justify-content: center;
    display: flex;
    padding: ${SiteSpacings.Spacing03.sm}px;

    a {
      display: inline-block;

      img {
        display: inline-block;
      }

      svg {
        display: block;
        width: 16px;
        height: auto;

        path {
          transition: fill 0.3s cubic-bezier(0.25, 1, 0.5, 1);
        }
      }

      &:hover {
        svg {
          path {
            fill: ${Greyscale[300]};
          }
        }
      }
    }
  }
`
